import { Invitation } from '@wonderschool/common-base-types';

import { WS_AUTH_ENDPOINTS } from './types';
import { wsAuthFetchBase } from './utils';

interface InvitationWithId extends Invitation {
  id: string;
}
export async function getPendingInvitation(email: string): Promise<InvitationWithId | null> {
  return (await wsAuthFetchBase({
    endpoint: WS_AUTH_ENDPOINTS.getInvitation,
    payload: {
      email,
    },
  })
    .then((res) => res.json())
    .catch((err) => {
      throw new Error(err);
    })) as InvitationWithId | null;
}
